import news from './news'
import treasures from './treasures'
import question from './question'
import exhibition from './exhibition'
import study from './study'
import activity from './activity'
import volunteers from './volunteers'
import appointment from './appointment'
import cultural from './cultural'
import knowledge from './knowledge'
import feedback from './feedback'
import search from './search'

const api = Object.assign(
    news,
    treasures,
    question,
    exhibition,
    study,
    activity,
    volunteers,
    appointment,
    cultural,
    knowledge,
    feedback,
    search,
);
export default api;